module.exports = __webpack_public_path__ + "static/media/warning.32da581f.svg";